import React, {useEffect, useRef, useState} from "react";
import "./DilateStatusCard.scss";

import moment from "moment";
import {convertTimeSignatureToMins, formatDateToString} from "helper/common";
import {useAppSelector} from "redux/hooks";
import {FORMAT_TIME} from "types/enums";
import {Tooltip} from "antd";
const DilateStatusCard = props => {
  const [thuocTra, setThuocTra] = useState<any>();
  const listThuocTraMat = useAppSelector(
    state => state.nurseOut.listThuocTraMat
  );
  const {status, name, timeDilate, isStop, active = true} = props;
  const [hourRealtime, setHourRealtime] = useState(0);
  const [secRealtime, setSecRealtime] = useState(0);
  const [minRealtime, setMinRealtime] = useState(0);
  const [_status, setStatus] = useState(status);
  const [_isStop, setIsStop] = useState(status);
  let interval = useRef<any>();
  const getThuocTra = () => {
    var value = listThuocTraMat.find((e, index) => e.tenVietTat == name);
    setThuocTra(value);
  };
  useEffect(() => {}, [status]);
  useEffect(() => {
    setStatus(status);
  }, [status]);
  useEffect(() => {
    setIsStop(isStop);
  }, [isStop]);

  useEffect(() => {
    getThuocTra();
  }, [listThuocTraMat]);
  useEffect(() => {
    // interval.current = setInterval(() => {
    //   const {min, second} = convertTimeSignatureToMins(
    //     moment().format(),
    //     moment(timeDilate).format()
    //   );
    //   setMinRealtime(min);
    //   setSecRealtime(second);
    // }, 1000);
  }, []);
  useEffect(() => {
    clearInterval(interval.current);
    interval.current = setInterval(() => {
      const {hour, min, second} = convertTimeSignatureToMins(
        moment().format(),
        moment(timeDilate).format()
      );
      setHourRealtime(hour);
      setMinRealtime(min);
      setSecRealtime(second);
    }, 1000);
  }, [timeDilate]);
  useEffect(() => {
    if (hourRealtime == 2) {
      setStatus(2);
    }
  }, [hourRealtime]);
  useEffect(() => {}, [_status]);

  return (
    <Tooltip title={active ? "Nhấn để thực hiện tra thuốc" : null}>
      <div className="dilate-status-card">
        {_status == 0 && <div className="no-dilate"></div>}
        {_status == 1 && (
          <div className="expired">
            {name}{" "}
            <span>
              {hourRealtime}:{minRealtime}:{secRealtime}
            </span>
          </div>
        )}
        {_status == 2 && <div className="valid">{name}</div>}

        {isStop == false && _status != 2 && (
          <div className="expired">
            {name}{" "}
            <span>
              {hourRealtime}:{minRealtime}:{secRealtime}
            </span>
          </div>
        )}
        {isStop && _status != 2 && <div className="valid">{name}</div>}
      </div>
    </Tooltip>
  );
};
export default DilateStatusCard;
